import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ROUTES } from 'routes';
import { AppContainer, AuthPageInfo } from 'components';
import { LoginPage } from './LoginPage';
import { RegisterPage } from './RegisterPage';
import { ResetPasswordPage } from './ResetPasswordPage';
import './AuthPage.scss';

export const AuthPage = (): React.ReactElement => {
  return (
    <AppContainer>
      <main className="auth-page">
        <div>
          <Switch>
            <Route exact path={ROUTES.login} component={LoginPage} />
            <Route exact path={ROUTES.register} component={RegisterPage} />
            <Route exact path={ROUTES.resetPassword} component={ResetPasswordPage} />
            <Redirect to={ROUTES.login} />
          </Switch>
          <AuthPageInfo />
        </div>
      </main>
    </AppContainer>
  );
};
